import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/config/tanstack-querykeys.config'
import { USER_STALE_TIME } from '@/config/tanstack-query-settings.config'

type Response = Transformed.GetUserResponse & {
  loading: boolean
  error: Nullable<Error>
}

const defaultUserResponse: Transformed.GetUserResponse = {
  user: null,
  membership: null,
  membershipMeta: null,
  membershipDetails: null,
}

const useUser = (): Response => {
  const userQuery = useQuery({
    queryKey: [QUERY_KEYS.USER],
    queryFn: async () => {
      const response = await fetch('/api/auth', { method: 'POST' })

      if (response.ok) {
        return response.json()
      }

      return null
    },
    staleTime: USER_STALE_TIME,
    refetchInterval: (response) => {
      // if we have a user, we want to refetch every USER_STALE_TIME
      if (response.state.data?.user) {
        return USER_STALE_TIME
      }
      return false
    },
  })

  const userData = userQuery.data
    ? userQuery.data
    : defaultUserResponse

  return {
    ...userData,
    loading: userQuery.isLoading,
    error: userQuery.error,
  }
}

export default useUser
